const selectDate = (from, to, isLast) => {
    return isLast ? to : from
}

export default selectDate;